import { OtpField } from "@/components/ui/otp-field"

interface QuestionOtpInputProps {
  value: string | undefined
  onChange: (value: string) => void
  disabled?: boolean
  length: number | undefined
}

export function QuestionOtpInput({
  value,
  onChange,
  disabled,
  length,
}: QuestionOtpInputProps) {
  // length is required and validated server-side; render an error if it slipped through.
  if (typeof length !== "number" || length <= 0) {
    return (
      <div className="rounded-md border border-red-6 bg-red-2 p-3 text-sm text-red-11">
        OTP question is misconfigured: missing or invalid{" "}
        <code>config.length</code>
      </div>
    )
  }

  return (
    <OtpField
      length={length}
      value={value ?? ""}
      onValueChange={onChange}
      disabled={disabled}
    />
  )
}
